module.exports = __webpack_public_path__ + "img/plan-03-m.c38dc772.png";